<template>
    <component :is="tag">
        <slot
            :proposal-step="step"
            :campaign="campaign"
            :proposal="proposal"
            :contact="contact"
            :network-id="networkId"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :patch-proposal-step="patchProposalStep"
            :force-reload-contact="forceReloadContact"
            :force-reload-proposal="forceReloadProposal"
            :connection-source-request-data="connectionSourceRequestData"
            :connection-source="connectionSource"
            :handle-complete-connection="handleCompleteConnection"
            :handle-failed-connection="handleFailedConnection"
            :handle-connect-instagram="handleConnectInstagram"
        />
    </component>
</template>

<script>
    import BaseProposalStepMixin from '../mixins/BaseProposalStepMixin';
    import { NAME_NETWORKS } from '../../../constants/proposal-steps';
    import NetworkConnectionSourceMixin from '../mixins/NetworkConnectionSourceMixin';

    export default {
        name: 'NetworksProvider',
        mixins: [BaseProposalStepMixin, NetworkConnectionSourceMixin],
        computed: {
            step() {
                return this.proposalSteps[NAME_NETWORKS];
            },
            networkId() {
                return +this.$route.query.networkId || +this.$route.params.networkId;
            }
        },
        methods: {
            forceReloadContact() {
                this.loadContact(true);
            },
            forceReloadProposal() {
                this.loadProposal(true);
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([this.loadCampaign(), this.loadProposal()]);
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    };
</script>
